// @ts-nocheck
interface ActionButton {
  label: string;
  icon?: string;
  onClick?: () => void;
  variant?: "primary" | "neutral";
}

interface PageHeaderProps {
  title: string;
  breadcrumbs?: string[];
  actions?: ActionButton[];
}

export function PageHeader({ title, breadcrumbs = [], actions = [] }: PageHeaderProps) {
  return (
    <div className="bg-[#f8f9fe] pb-4 px-6 pt-6">
      <div className="flex items-center justify-between">
        <div>
          <nav className="flex items-center gap-1.5 text-xs text-[#8898aa] mb-1">
            <a href="/dashboard" className="hover:text-[#1171ef]">
              <i className="fas fa-home" />
            </a>
            {[title, ...breadcrumbs].map((crumb, i) => (
              <span key={i} className="flex items-center gap-1.5">
                <span>/</span>
                <span className={i === breadcrumbs.length ? "text-[#525f7f] font-medium" : ""}>{crumb}</span>
              </span>
            ))}
          </nav>
          <h1 className="text-xl font-semibold text-[#32325d]">{title}</h1>
        </div>
        {actions.length > 0 && (
          <div className="flex items-center gap-2">
            {actions.map((action, i) => (
              <button
                key={i}
                onClick={action.onClick}
                className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors shadow-sm ${
                  action.variant === "primary"
                    ? "gradient-primary text-white hover:opacity-90"
                    : "bg-white border border-[#e9ecef] text-[#525f7f] hover:bg-[#f5f7ff] hover:text-[#1171ef]"
                }`}
              >
                {action.icon && <i className={`${action.icon} text-xs`} />}
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
